/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StartManualValidationDto
 */
export interface StartManualValidationDto {
    /**
     * Created or processed Workflow instance Id
     * @type {string}
     * @memberof StartManualValidationDto
     */
    workflowInstanceId: string;
    /**
     * Numeric metric of the solution
     * @type {number}
     * @memberof StartManualValidationDto
     */
    score: number;
    /**
     * Human-readable report of automated operation
     * @type {string}
     * @memberof StartManualValidationDto
     */
    report: string;
}

/**
 * Check if a given object implements the StartManualValidationDto interface.
 */
export function instanceOfStartManualValidationDto(value: object): boolean {
    if (!('workflowInstanceId' in value)) return false;
    if (!('score' in value)) return false;
    if (!('report' in value)) return false;
    return true;
}

export function StartManualValidationDtoFromJSON(json: any): StartManualValidationDto {
    return StartManualValidationDtoFromJSONTyped(json, false);
}

export function StartManualValidationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): StartManualValidationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'workflowInstanceId': json['workflowInstanceId'],
        'score': json['score'],
        'report': json['report'],
    };
}

export function StartManualValidationDtoToJSON(value?: StartManualValidationDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'workflowInstanceId': value['workflowInstanceId'],
        'score': value['score'],
        'report': value['report'],
    };
}

